import React from 'react';
import WizardLeft from '../../components/common/wizard_left'
import services from '../../services';
import $ from 'jquery';
import { toast } from 'react-toastify';
import { Button } from '@progress/kendo-react-buttons'
import { Row } from 'antd';
import { withRouter } from 'react-router-dom';
import GoogleMapPopUp from '../../components/common/GoogleMapPopUp';
import BoletimmainFrom from '../../components/MainPageComponent/BoletimmainFrom';
import BoletimFormNavbar from '../../components/common/Boletim_navbar';
import BoletimRightPanel from '../../components/Boletim-right-panel/boletim-right-panel';
import moment from 'moment';

const dateFormat = "YYYY-MM-DD";

const queryString = require('query-string');

const parcel = []

let combolistrequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": false,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

const boletimDefaultDataRow = {
    "boletimAbrigo" :{
          "idTpAbrigo" : null,
          "percentagem" : null
        },
      "boletimNaturezaTerreno":{
          "idTpNaturTerr": null,
          "percentagem": null,
        },
      "boletimPedregosidade":{
          "idTpPedregosidade": null,
          "percentagem": null,
        },
      boletimCompassoPlantacao:{
          "linha1" : null,
          "linha2" : null,
          "linha3" : null,
          "entreLinha1" : null,
          "entreLinha2" : null
        },
      boletimModoConducao:{
          "idTpArmacaoForma" : "",
          "idTpArmacao" : "",
          "alturaArame1" : ""
        },
      boletimPortaEnxertos:{
          "idTpPortaEnxertos" : null,
          "percentagem" : null
        },
      boletimDetalhesPovoamento:{
          "bacelos": null,
          "enxertos1": null,
          "videiras2": null,
          "videiras3": null,
          "videiras4A25": null,
          "videirasMaior25": null,
          "falhas": null,
        }
}

class BoletimForm extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {
                boletim : {}
            },
            all_list: {},
            id: '',
            sel_nev: "parcel",
            headName: null,
            params: {},
            AllVisiable: {},
            AllEnable: {
                PAPV:false
            },
            estado : '10',
            
        }
    }


    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        let headName = "Inserir Boletim";
        
        this.setState({
            headName,
            params: parsed
        })
        if (parsed.id) {
            document.title = 'AGPP - Edição Boletim';
            this.getparceldetails(parsed);
        }else{
            document.title = 'AGPP - Detalhes Boletim';
        }
        this.updatesel_nev('parcel')
        this.getAllLIst();
    }

    isEnable = (name) => {
        let AllEnable = { ...this.state.AllEnable }
        if (AllEnable[name] === true || AllEnable[name] === false)
            return AllEnable[name] ? false : true;
        else return false;
    }
    isVisiable = (name) => {
        let AllVisiable = { ...this.state.AllVisiable }
        if (AllVisiable[name] === true || AllVisiable[name] === false) {
            return AllVisiable[name];
        }
        else return true;
    }


    Inactiva = (status) => {
        let AllEnable = { ...this.state.AllEnable }
        let AllVisiable = { ...this.state.AllVisiable }
        let full = false;
        if (status === "I") {
            full = true;
        }
        AllVisiable.btnCalculaDados = false;
        AllEnable.numparc = false;
        AllEnable.geocod = false;
        AllEnable.numparant = false;
        AllEnable.sitdeclar = false;
        AllEnable.desparc = false;
        AllEnable.pontuacao = false;
        AllEnable.dtultvist = false;
        AllEnable.codlitigio = false;
        AllEnable.fatordporto = false;
        AllEnable.areaprojectada = false;
        AllEnable.anoplantacao = false;
        AllEnable.estimatedProduction = false;
        AllEnable.idclasseplant = false;
        AllEnable.pontuacao = full;
        AllEnable.idclasseplant = false;


        AllEnable.bacelosileg = false;
        AllEnable.enxertoS1ILEG = false;
        AllEnable.videiraS2ILEG = false;
        AllEnable.videiraS3ILEG = false;
        AllEnable.videiraS4A25ILEG = false;
        AllEnable.videirasmaioR25ILEG = false;

        AllEnable.pcttinta = false;
        AllEnable.pctbranca = false;
        AllEnable.pctrose = false;
        AllEnable.pctmoscatel = false;

        // AllEnable.compasso = false;
        AllEnable.densidade = false;
        AllEnable.prctLss3AndFailures = false;
        AllEnable.prctfaults = false;
        // AllEnable.pesmaioR3 = false;
        // AllEnable.pesmenoR3 = false;
        // AllEnable.pesilegais = false;
        AllEnable.pestotals = false;
        // AllEnable.pesramleg = false;
        // AllEnable.falhasram = false;
        // AllEnable.pesfalileg = false;
        // AllEnable.pesfalleg = false;
        // AllEnable.pescastasnaoaptas = false;
        // AllEnable.pessemaramacao = false;
        // AllEnable.armacaoterreno = false;

        AllEnable.bacelos = false;
        AllEnable.enxertoS1 = false;
        AllEnable.videiraS2 = false;
        AllEnable.videiraS3 = false;
        AllEnable.videiraS4A25 = false;
        AllEnable.videirasmaioR25 = false;
        AllEnable.bacelosileg = false;
        AllEnable.enxertoS1ILEG = false;
        AllEnable.videiraS2ILEG = false;
        AllEnable.videiraS3ILEG = false;
        AllEnable.videiraS4A25ILEG = false;
        AllEnable.videirasmaioR25ILEG = false;


        if (full) {
            AllEnable.legalizavel = false;
            AllEnable.idsitparc = false;
            AllEnable.idsitleg = false;
            // btnGravarComent.Visible = True
            // linkPrint.Visible = False
            // proprietarios1.SetReadOnly()
            // NovoArtigoMatricial1.SetReadOnly()
            // txtTitularDireito.Enabled = False
            // btnProcTit.Visible = False
            // painelAddExplorador.Visible = False
            // grvExplorador.Enabled = False
            // btnGetPtCastas.Visible = False
            // imgCalcPontuacao.Visible = False
            // cpeObs.Collapsed = False
        }

        this.setState({
            AllEnable,
            AllVisiable
        })
    }

    getAllLIst = () => {
        // this.getlist_new('busentdistrito');
        this.getlist('legalPlot');
        // this.getlist('LitigationSituation');
        this.getlist('Irrigacao');
        this.getlist('Abrigo');
        this.getlist('Natureza');
        this.getlist('Pedregosidade');
        this.getlist('Forms');
        this.getlist('Portaenxertos');
        this.getlist('ClassPlantation');
        this.getlist('Cultura');
        this.getlist('DouroPort');
        this.getlist('Armterreno');
        this.getlist('BusUtilizador')
        this.getlist('Utilizacao');
        this.getlist_new('Sinonimo');
        this.getlist_new('Casta');
        this.getlist('colors');
        //this.getlist('SitucaoDaBoletim');
    }

    /* Api chamando dados da tabela */

    getlist = async (listname) => {
        let res = await services.apiCall.requestApi("allservice/" + listname, combolistrequest, 'post');
        if (res) {
            let all_list = { ...this.state.all_list }
            all_list[listname] = res
            this.setState({
                all_list
            })
        }
    }

    getlist_new = async (listname) => {
        let res = await services.apiCall.requestApi(listname + "/GetAll", combolistrequest, 'post');
        if (res) {
            let all_list = { ...this.state.all_list }
            all_list[listname] = res
            this.setState({
                all_list
            })
        }
    }


    /*  Para fechar pop-up  */

    closePopup = () => {
        $(".left-popup").trigger('click');
        this.updatesel_nev(this.state.sel_nev);
    }



    getrightformdata = (data) => {
        console.log("right data", data)
        this.setState({
            data: data
        })
    }

    getcenterformdata = (data) => {
        this.setState({
            data: data
        })

    }

    getparceldetails = async (parsed) => {
        let data = {
            NumBoletim: parseInt(parsed.id),
            Versao: parseInt(parsed.versao)
        }
        let res = await services.apiCall.requestApi("/boletim/GetById", data, 'post');

        if (res) {
            console.log("the response of the process api is.....", res)
            let headName = res.status === "I" ? "HISTÓRICO DA Boletim" : "Edit Boletim";
            document.title = res.status === "I" ? "AGPP - Histórico Boletim" : parsed.id ? 'AGPP - Edição Boletim' : 'AGPP - Detalhes Boletim';
            this.Inactiva(res.status);
            Object.keys(res).map(k => {
                if(Array.isArray(res[k]) && Object.keys(boletimDefaultDataRow).includes(k)){
                    res[k].push(boletimDefaultDataRow[k])
                }
            })
            // let status = res.boletimCastas && res.boletimCastas[0].status && res.boletimCastas[0].status === 'Inativo' ? "I":"A"
            // let boletimCastas = []
            // boletimCastas.push({...res.boletimCastas[0], status})
            // console.log("boletimCastas is ;;;;;", boletimCastas)
            this.setState({
                //data: {...res, boletimCastas},
                data: res,
                id: parsed.id,
                headName,
                estado : res.boletim && res.boletim.idEstado || '10'
            },() => {
                console.log("the data to be tested is.... ", this.state.data)
            })
        }
    }

    scrolthis = (sel_nev) => {
        if ($('#' + sel_nev).length)
            $('html, body').animate({
                scrollTop: $('#' + sel_nev).offset().top - 95 //#DIV_ID is an example. Use the id of your destination on the page
            }, 'slow');
    }

    checkDicofre = (newDicofre) => {
        console.log("newDicofre is.... ",typeof newDicofre)
        
        
        let codDistrito = +(newDicofre.substr(0,2))
        let codConcelho = +(newDicofre.substr(2,2))
        let codFreguesia = +(newDicofre.substr(4,2))
        
        // console.log("00000000 codDistro is ", codDistrito)
        // console.log("00000000 codConcelho is ", codConcelho)
        // console.log("00000000 codFreguesia is ", codFreguesia)
        return {
            codDistrito,
            codConcelho,
            codFreguesia
        }

    }

    handleSubmit = (e,callFor) => {
        let testArray = ["dicofre","castas","proprietarios","areaParcela","nomeParcela","estadoVinha","nifExplorador"]
        let validateObj = {}
        console.log("call for",callFor)
        const parsed = queryString.parse(this.props.location.search);
        if(callFor === 'gravar'){
            this.handleGraver(e,parsed, callFor)
        }
        if(callFor === 'validar') {
            let isValid = this.validateMandatoryFields(this.state.data.boletim, callFor)
            console.log("the validation for validar is.... ", isValid)

            let url = '/boletim/ObterPontuacaoParcela'
            let req = {}
            req.loginEncriptadoUtilizador = 'c860c97832aaeb343255ecb1acfcc48ecb223ca22dd2cb01'
            req.geocodigo = '251414472685'
            req.tipoOperacao = '1' 
            services.apiCall.requestApi(url, req, 'post') //========= api call for validation
                .then(res => {
                    let area, boletim, dicofreResult, boletimExplorador = []
                    console.log("the response for validation is ", res)
                    testArray.map(key => {
                        validateObj[key] = res.parametrosClassificacao[key]

                        switch (key) {
                            case "dicofre": 
                                dicofreResult = this.checkDicofre(res.parametrosClassificacao[key])                   
                                break;
                            
                            case "castas": 
                            
                                break;
                            
                            case "proprietarios": 

                                break;
                            
                            case "areaParcela": 
                                area = res.parametrosClassificacao[key]
                                
                                
                                break;
                            
                            case "nomeParcela": 
                            
                                break;
                            
                            case "estadoVinha": 
                            
                                break;
                            
                            case "nifExplorador": 
                                let nif = "503249173"
                                if(nif) {
                                    boletimExplorador[0] = {nif}
                                }
                                break;
                            
                            default:
                                break;
                        }

                    })
                    boletim = {...this.state.data['boletim'], area, ...dicofreResult}
                    this.setState({
                        data: {...this.state.data, boletim, boletimExplorador}
                    })
                    console.log("the validated object is...... ", validateObj)
                })
                .catch(error => {
                    console.log("error is ",error)
            })


        }
        else if(callFor === 'finalizar'){
            e.persist()
            this.handleGraver(e,parsed, callFor)
        }
    }


    validateMandatoryFields = (data, callFor) => {
        console.log("theeeeee newwwwww dataaaaa ", data )
        let isValid = true
        let validationArray = []
        let gravarValidateKeysArr = ["Geocodigo","CodAgente1","CodAgente2","DataBoletim","ExloradorRepresentante"]
        let validorValidateKeysArr = ["geocodigo","codAgente1","codAgente2","dataBoletim","exloradorRepresentante"]
        if(callFor === "gravar") {
            validationArray = gravarValidateKeysArr
        }
        else if(callFor === "validar" || callFor === "finalizar") {
            validationArray = validorValidateKeysArr
        }
        
        validationArray.map(key => {
            //console.log("the key is 777777777777777777", key)
            if(!data[key]){
                isValid = false
            }
        })
        return isValid
    }

    handleGraver = async (e,parsed, callFor) => {
        let url = '/boletim/'
        let isValid = null
        let data = { ...this.state.data }
        data['boletim']['idEstado'] = 11
        let formData = new FormData();
        Object.keys(data).map(key => {    
            let newKey = ''
            newKey = key.substr(0,1).toUpperCase() + key.substr(1,key.length)
            let newData = this.customizedData(newKey , data[key])
            
            
            
            if(newKey === 'Boletim') {
                isValid = this.validateMandatoryFields(newData, callFor)
                console.log("the value that validates is///////// ", isValid)
                delete newData['AssinaturaAgente1']
                delete newData['AssinaturaAgente2']
                formData.append(key,JSON.stringify(newData))
            }
            else formData.append(newKey,JSON.stringify(newData))
        })

        if(data.boletim.assinaturaAgente1) formData.append('AssinaturaAgente1',data.boletim.assinaturaAgente1)
        if(data.boletim.assinaturaAgente2) formData.append('AssinaturaAgente2',data.boletim.assinaturaAgente2)

        if (parsed.id || callFor === "finalizar") {
            url += `updateboletim`
            // formData.append('NumBoletim', parsed.id)
            // formData.append('Versao', parsed.versao)
        } else {
            url += 'createboletim'
        }
        if(!isValid){
            toast.error("Verifique o conteúdo dos campos obrigatórios.")
            return
        }
        let res = await services.apiCall.requestApi(url, formData, 'post');
        if (res) {
            let estado = ''
            if(this.state.estado == "10") estado = "11"
            else if(this.state.estado == "11") estado = "12"
            else if(this.state.estado == "12") estado = "13"
            else if(this.state.estado == "13") estado = "15"
            else if(this.state.estado == "15") estado = "14"
            
            this.setState({estado})
        }
    }

    customizedData = (key,data) => {
        if(Array.isArray(data)){
            let newDataArray = []
            data.map(_r => {
                let newRow = this.changeObjectKeyData(_r,key)
                let checkRow = this.checkRow(_r,key)
                if(checkRow) newDataArray.push(newRow)
            })
            return newDataArray
        }else{
            return this.changeObjectKeyData(data,key)
        }
    }

    checkRow = (row,key) => {
        let cond = true
        Object.keys(row).map(_k => {
            if(_k.substr(0,2).includes('id') && !row[_k]) cond = false
        })

        return cond;
    }

    changeObjectKeyData = (data, modulename) => {
        let newKey = ''
        let newData = {}
        let dataObjKeyArray = Object.keys(data)
        dataObjKeyArray.map(key => {
            if(key.substr(0,2).includes('id')){
                newKey = key.substr(0,2).toUpperCase() + key.substr(2,key.length)
            }else{
                newKey = key.substr(0,1).toUpperCase() + key.substr(1,key.length)
            }
            if(newKey === 'Administrativo'){
                if(typeof data['administrativo'] !== "boolean"){
                    newData['Administrativo'] = data['administrativo'] === 'Sim' ? true : false
                }else{
                    newData['Administrativo'] = data['administrativo']
                }
            }else if(newKey === 'Versao') {
                delete data['versao']
            }else if(newKey === 'Index'){
                delete data['index']
            }else if(newKey === 'Modulename'){
                delete data['modulename']
            }else if(newKey === 'TotalCount'){
                delete data['totalCount']
            }else{
                if(modulename === 'Boletim' && !data['dataBoletim']) newData['DataBoletim'] = moment(new Date()).format(dateFormat)
                if(data[key]) newData[newKey] = !isNaN(data[key]) ? +data[key] : data[key]
                else newData[newKey] = data[key]
            }
        })
        return newData;
    }

    /* Deletar linha da tabela de dados */

    handleDelete = async (status) => {
        let parsed = queryString.parse(this.props.location.search);
        // console.log("status", status)
        if(status){
            let data = {
                id : +parsed.id,
                versao : +parsed.versao
            }

            let res = await services.apiCall.requestApi('/parcel/delete',data,'post')
            if(res){
                this.props.history.push({
                    pathname : "/dashboard"
                })
            }
        }
    }

    updatesel_nev = (sel_nev) => {
        this.setState({
            sel_nev
        });
        
        if($('#' + sel_nev).length) {
            $('html, body').animate({
                scrollTop: $('#' + sel_nev).offset().top - 200 //#DIV_ID is an example. Use the id of your destination on the page
            }, 'slow');
        }      
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {

        return (
            // <LocalizationProvider language="pt-PT">
            // <IntlProvider locale="pt-PT" >
            <div className="dashboard">
                <BoletimFormNavbar to="/boletim" handleDelete={(status) => this.handleDelete(status)} showDelete={true} handleSubmit={(data, callFor) => this.handleSubmit(data, callFor)} type="parcelas" estado={this.state.estado} headName={this.state.headName} />
                <div className="full-container edit-ward-boletim" style={{paddingTop: "163px"}}>
                    <WizardLeft date={new Date()} id={this.state.id ? this.state.id : null} updatesel_nev={(sel_nev) => this.updatesel_nev(sel_nev)} sel_nev={this.state.sel_nev} type="Boletims" />
                    <BoletimmainFrom 
                        date={new Date()}
                        id={this.state.id}
                        boletimData={this.state.data}
                        all_list={this.state.all_list}
                        closePopup={() => this.closePopup()}
                        getcenterformdata={(data) => this.getcenterformdata(data)}
                        updatesel_nev={(sel_nev) => this.updatesel_nev(sel_nev)}
                        isVisiable={(name) => this.isVisiable(name)}
                        isEnable={(name) => this.isEnable(name)}
                    />
                    <BoletimRightPanel date={new Date()} Parcel={this.state.data} all_list={this.state.all_list} closePopup={() => this.closePopup()} handleSubmit={(data) => this.getrightformdata(data)} />
                </div>
                {
                    <div className="modal" id="google-map-popup">
                        <div className="modal-dialog modal-lg">
                            <GoogleMapPopUp />
                        </div>
                    </div>
                }
                

            </div>
            // </IntlProvider>
            // </LocalizationProvider>
        )
    }
}

export default withRouter(BoletimForm);